import { Component } from "react";
import "./Beforeexit.css";

class Beforeexit extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {}

  doClosePop = () => {
    document.querySelector(".exit-before-popup").classList.remove("active");
  };

  render() {
    return (
      <div className="exit-before-popup">
        <div className="ebef_window">
          <div
            className="ebef_close"
            onClick={() => {
              this.doClosePop();
            }}
          >
            &times;
          </div>
          <div className="ebef_title">
            Da li Vam je ovaj oglas zapao za oko?
          </div>
          <div className="ebef_text">
            Ukoliko imate pitanja ili želite bolju ponudu uvijek možete
            kontaktirati prodavca za više informacija.
          </div>
          <div className="ebef_text">
            Za neke oglase možete dobiti nižu cjenu ili dodatne pogodnosti kao
            besplatnu dostavu ili dodatne poklone.
          </div>
          <div
            className="contact_button1"
            onClick={() => {
              this.doClosePop();
            }}
          >
            Nazad na oglas
          </div>
        </div>
      </div>
    );
  }
}

export default Beforeexit;
